import en from './en/en.json';

export default {
  en: en,
};
